import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { useState, useEffect, component } from 'haunted';
import { ProgressContainer } from '@local/templates/progress-container';
import { matomoTrack } from '@arr2019/stats-matomo';
import { sanitizeHtml } from '@local/sanitize-html';
import { TypeLink } from '@local/webcomponents-type-link';
import { formatString } from '@outbook/format-string';
import { getI18n } from './_i18n/i18n.js';

function NewsDetailComponent(element) {
  const { props } = element;
  const {
    id,
    slug,
    baseRoute = '',
    locale,
    literals = getI18n(locale)
  } = props;

  const [viewModelDetail, setViewModelDetail] = useState(null);

  useEffect(() => {
    const newsKey = id || slug;
    if (!newsKey || viewModelDetail !== null) {
      return;
    }

    const headers = locale ? { 'X-Locale': locale } : undefined;
    const detailPath = id
      ? `${baseRoute}/q/news/detail/${encodeURIComponent(String(id))}`
      : `${baseRoute}/q/news/detail/${encodeURIComponent(slug)}`;

    fetch(detailPath, {
      headers
    })
      .then(response => response.json())
      .then(data => {
        setViewModelDetail(data?.news?.[0] ?? null);
        matomoTrack();
      })
      .catch(() => setViewModelDetail(null));
  }, [id, slug, viewModelDetail]);

  return html`
    <div class="news-detail">
      ${
        viewModelDetail
          ? html`
              ${
                viewModelDetail.image && viewModelDetail.youtube
                  ? html`
                      <div class="mb-6 flex justify-center">
                        <img
                          src="${viewModelDetail.image}"
                          alt=""
                          class="w-full h-auto max-w-2xl"
                          aria-hidden="true"
                        />
                      </div>
                    `
                  : html``
              }

              <header class="mb-4">
                <h2 class="heading--level-2 mb-2">${viewModelDetail.title}</h2>
                <p class="card__date">${viewModelDetail.created}</p>
              </header>

              <div class="news-content mb-6">
                ${unsafeHTML(sanitizeHtml(viewModelDetail.content))}
              </div>

              <p>
                ${TypeLink({
                  text: literals.watchOnYoutube,
                  label: formatString(literals.watchOnYoutubeLabel, [
                    viewModelDetail.title
                  ]),
                  target: '_blank',
                  url: viewModelDetail.youtube
                })}
              </p>
            `
          : ProgressContainer({})
      }
    </div>
  `;
}

customElements.define(
  'outbook-news-detail',
  component(NewsDetailComponent, { useShadowDOM: false })
);

export function NewsDetail(props) {
  return html`<outbook-news-detail .props="${props}"></outbook-news-detail>`;
}
